import moment from 'moment'

// Libellés et couleurs des valeurs renvoyées par l'API (cf. vadimm-api app/constants.py)

export const RESERVATION_STATUS = {
  pending: { label: 'En attente', tone: 'neutral' },
  editing: { label: 'En édition', tone: 'neutral' },
  pre_reserved: { label: 'Pré-réservée', tone: 'warning' },
  reserved: { label: 'Réservée', tone: 'info' },
  sold: { label: 'Vendue', tone: 'success' },
  canceled: { label: 'Annulée', tone: 'danger' },
  refused: { label: 'Refusée', tone: 'danger' }
}

export const LOT_STATUS = {
  draft: { label: 'Brouillon', tone: 'neutral' },
  available: { label: 'Disponible', tone: 'success' },
  optioned: { label: 'Optionné', tone: 'violet' },
  pre_reserved: { label: 'Pré-réservé', tone: 'warning' },
  reserved: { label: 'Réservé', tone: 'info' },
  sold: { label: 'Vendu', tone: 'neutral' }
}

export const PROGRAM_STATUS = {
  draft: { label: 'Brouillon', tone: 'neutral' },
  available: { label: 'Disponible', tone: 'success' },
  archived: { label: 'Archivé', tone: 'neutral' }
}

export const ACCOUNT_TYPE = {
  promoteur: { label: 'Promoteur', tone: 'violet' },
  commercial: { label: 'Commercialisateur', tone: 'info' }
}

export const USER_PROFIL = {
  superadmin: { label: 'Superadmin', tone: 'danger' },
  admin: { label: 'Admin', tone: 'info' },
  manager: { label: 'Manager', tone: 'violet' },
  seller: { label: 'Vendeur', tone: 'neutral' },
  agent: { label: 'Agent', tone: 'neutral' },
  api: { label: 'API', tone: 'neutral' },
  external_api: { label: 'API externe', tone: 'neutral' },
  service: { label: 'Service', tone: 'neutral' },
  stat_api: { label: 'API stats', tone: 'neutral' }
}

export function toOptions (dict) {
  return Object.entries(dict).map(([value, s]) => ({ value, text: s.label }))
}

export function pillClass (dict, value) {
  return `pill pill--${(dict[value] || {}).tone || 'neutral'}`
}

export function labelOf (dict, value) {
  return (dict[value] || {}).label || value || '—'
}

// Les filtres booléens de l'API attendent 1 / 0
export const YES_NO = [{ value: '1', text: 'Oui' }, { value: '0', text: 'Non' }]

export function formatDate (value) {
  const d = moment.utc(value, moment.ISO_8601)
  return value && d.isValid() ? d.local().format('DD/MM/YYYY') : '—'
}

// Filtre « mois » (AAAA-MM) vers les bornes attendues par le service de facturation
export function monthRange (month) {
  return {
    date__gte: moment(month).startOf('month').utc().toISOString(),
    date__lte: moment(month).endOf('month').utc().toISOString()
  }
}

export function formatPrice (value) {
  return value || value === 0 ? `${Number(value).toLocaleString('fr-FR')} €` : '—'
}
